// Utilità condivise del portale.

// Id operazione per l'idempotenza del BE (client_operation_id).
export function genOperationId() {
    if (typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
    }
    return 'op-' + Date.now() + '-' + Math.random().toString(16).slice(2);
}

// Scala dei DECIMAL(15,5) in DB e tolleranza sui confronti: gemelli di
// packagingStock_model::SCALE / ::EPS.
export const QTY_SCALE = 5;
export const QTY_EPS = 0.000005;

// Parse numerico da INPUT UTENTE in formato IT (punto = migliaia, virgola = decimali).
//
// ⚠️ Solo su input utente. Su un valore GREZZO dell'API (`"103.12500"`, che è notazione
// macchina) il punto verrebbe letto come separatore di migliaia e il risultato sarebbe
// 10.312.500. Per i valori che arrivano dal BE usare `Number(...)`.
export function toNum(v) {
    if (v === '' || v === null || v === undefined) return 0;
    const n = parseFloat(String(v).replace(/\./g, '').replace(',', '.'));
    return isNaN(n) ? 0 : n;
}

// Due quantità sono la stessa quantità? Confronto con la tolleranza dei DECIMAL(15,5):
// `===` su float ricostruiti da stringhe diverse non è affidabile.
export function sameQty(a, b) {
    return Math.abs((Number(a) || 0) - (Number(b) || 0)) < QTY_EPS;
}

// Formattazione quantità IT (separatore migliaia '.', decimali con la virgola, zeri finali
// tolti). Gemello di packagingStock_model::fmtQty() e di formatQty() nel gestionale.
//
// NON arrotonda all'intero: `qty_per_collo_whole` è DECIMAL(15,5) e può essere frazionaria
// per davvero (componenti a KG, righe legacy normalizzate dal backfill del 2026_07_29).
// Arrotondata, una riga da 2 colli × 5,5 pz si mostrava come "2 × 6 = 11 pz" — un'equazione
// falsa stampata in chiaro, che è ciò che ha fatto perdere fiducia nei numeri del modulo.
//
// NON usa toLocaleString/Intl, e il motivo è preciso: `it-IT` in CLDR ha
// minimumGroupingDigits = 2, quindi raggruppa da 5 cifre (12.345) ma NON a 4 → 2050 restava
// "2050". È tipografia italiana corretta, ma il gestionale usa number_format() che raggruppa
// SEMPRE: le due applicazioni mostravano la stessa giacenza in due modi diversi. Qui il
// separatore si inserisce a mano, così il portale è allineato all'ufficio e deterministico.
export function fmtQty(n) {
    const num = Number(n) || 0;
    // Arrotondamento alla scala della colonna: senza, 0.1+0.2 stamperebbe "0,30000000000000004".
    const rounded = Math.round(Math.abs(num) * 10 ** QTY_SCALE) / 10 ** QTY_SCALE;
    const [intPart, decPart = ''] = rounded.toFixed(QTY_SCALE).split('.');
    let out = '';
    for (let i = 0; i < intPart.length; i++) {
        if (i > 0 && (intPart.length - i) % 3 === 0) { out += '.'; }
        out += intPart[i];
    }
    const dec = decPart.replace(/0+$/, '');
    return (num < 0 ? '-' : '') + out + (dec ? ',' + dec : '');
}

// La riga È un collo aperto? Un collo aperto = una riga (qty_colli_partial sempre 1), con
// `partial_of_uuid` = riga interi di provenienza. Il MODO di prelievo si deriva da qui.
export function isPartialRow(row) {
    return !!Number(row && row.is_partial);
}

// Pezzatura di una riga di giacenza (pezzi per collo intero).
// Su una riga collo-aperto è la pezzatura di PROVENIENZA ("collo da 250"), non una giacenza.
// 0 = formato non impostato.
//
// MAI arrotondare: la pezzatura fa parte della CHIAVE di riga, quindi questo valore deve
// essere lo stesso che vede lockStockByKey lato server. Arrotondato, la disponibilità in
// prelievo si calcolava su colli × pezzatura_arrotondata (12 pz dove ce n'erano 11).
export function perColloOf(row) {
    return Number(row && row.qty_per_collo_whole) || 0;
}

// Pezzi nel bucket interi: sono DERIVATI da colli x pezzi/collo, mai digitati.
// Stessa derivazione del BE (packagingStock_model::derivePiecesWhole), che resta autoritativo.
// `toNum` perché gli argomenti arrivano dai campi del form (formato IT), non dall'API.
export function piecesWholeFrom(colliWhole, perColloWhole) {
    return toNum(colliWhole) * toNum(perColloWhole);
}
